module.exports = __webpack_public_path__ + "img/dajiajuhome2.3344e5ea.png";